import { Gesture, gestureLayers } from "./BaseGesture"

class MainViewBackgroundClickToBlur extends Gesture {
  override layer = gestureLayers.mainViewBackground

  override async onMouseDown(
    mouse: MouseEvent,
  ) {
    const { getCollectionViewFileFromEvent, isOverCollectionView, getFirstMatchingClassFromEvent } = useGestures()
    const { propertyEditorClass, navIgnoreMainViewGestures } = useGlobals()
    const { emitInterfaceEvent } = useEvents()
    if (getCollectionViewFileFromEvent(mouse) || !isOverCollectionView(mouse))
      return

    if (getFirstMatchingClassFromEvent(mouse, navIgnoreMainViewGestures))
      return

    if (getFirstMatchingClassFromEvent(mouse, propertyEditorClass))
      return this.debug("ignoring click inside property editor")

    this.debug("Background clicked, soft blurring")
    emitInterfaceEvent("afterSoftBlur", {})
  }
}

const handler = new MainViewBackgroundClickToBlur()
export default function () {
  return handler
}
